var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:['showRateEle',{fail:_vm.rateData<0,win:_vm.rateData>0}]},[_vm._v(" 环比 "),(_vm.rateData!==0)?_c('u',[_vm._v(_vm._s(_vm.rateData>0?'+':'')+_vm._s(_vm.rateData)+"%")]):_c('u',[_vm._v("-")])])}
var staticRenderFns = []

export { render, staticRenderFns }